import React from "react";
import {
  Box,
  CircularProgress,
  Modal,
  useTheme,
} from "@mui/material";

interface ICommonLoaderProps {
  isVisible: boolean;
}

const CommonLoader: React.FC<ICommonLoaderProps> = ({ isVisible }) => {

  const theme = useTheme()

  return (
    <Modal
      open={isVisible}
      aria-labelledby="loader-modal"
      aria-describedby="loader-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 24,
          p: 4,
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress
          sx={{ color: theme.palette.primary.main, alignSelf: "center", verticalAlign: "true" }}
        />
      </Box>
    </Modal>
  );
};

export default CommonLoader;
